import React, { Component } from "react";
import "./App.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import UniversalElement from "./UniversalElement";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import { connect } from "react-redux";
import { withRouter, Redirect, Route } from "react-router-dom";
import { NotificationsActive } from "@material-ui/icons";
import { SnackbarProvider } from "notistack";
import psl from "psl";
import ErrorPage from "./ErrorPage";
import { mutationObserver } from "./utils/NotificationObserver";
export class App extends Component {
  state = {
    theme: {},
  };
  componentDidMount() {
    mutationObserver(document.getElementById("notification-container"));
    let storedPalette = localStorage.getItem("palette");
    if (storedPalette) {
      storedPalette = JSON.parse(storedPalette);
      this.setState({
        theme: createMuiTheme({
          typography: { useNextVariants: true },
          palette: storedPalette,
        }),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.theme !== this.props.theme) {
      this.setState({ theme: this.props.theme });
    }
  }

  UniversalElementComponent = () => {
    return <UniversalElement style={{ height: "100%" }} />;
  };

  OAuth2RedirectHandler = () => {
    const token = this.getUrlParameter("token");
    const error = this.getUrlParameter("error");
    if (token) {
      localStorage.setItem("access_token", token);
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: this.props.location },
          }}
        />
      );
    } else {
      return (
        <Redirect
          to={{
            pathname: "/login/error",
            state: {
              from: this.props.location,
              error: error,
            },
          }}
        />
      );
    }
  };

  OIDCHandler = () => {
    let parsed = psl.parse(window.location.hostname);
    let organization = parsed.subdomain;
    if (!organization) {
      organization = "demo";
    }
    const redirect = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ":" + window.location.port : ""
    }/oauth2/redirect`;
    window.location.replace(
      `https://${
        this.props.apiLocation
      }/oauth2/authorize/${organization}?redirect_uri=${redirect}`
    );
    return null;
  };

  getUrlParameter = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");

    var results = regex.exec(this.props.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  render() {
    return (
      <div className="App" style={{ height: "100%" }}>
        <MuiThemeProvider
          theme={
            Object.entries(this.state.theme).length === 0
              ? createMuiTheme({ typography: { useNextVariants: true } })
              : this.state.theme
          }
        >
          <SnackbarProvider
            domRoot={document.getElementById("notification-container")}
            iconVariant={{
              info: <NotificationsActive style={{ marginRight: 8 }} />,
            }}
          >
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <ErrorPage>
                <Route path="/oidc/login" component={this.OIDCHandler} />
                <Route
                  path="/oauth2/redirect"
                  component={this.OAuth2RedirectHandler}
                />
                <Route path="/" component={this.UniversalElementComponent} />
              </ErrorPage>
            </MuiPickersUtilsProvider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  theme: state.theme.userTheme,
  apiLocation: state.setting.apiLocation,
});
export default withRouter(
  connect(
    mapStateToProps,
    null
  )(App)
);
